<kno2-dialog-body>
    <!-- prettier-ignore -->
    <p>
        Welcome to
        <strong>{{ brandDisplayName() }}</strong>, an affiliate of the
        <strong>Kno2 Connected&reg; healthcare network</strong>. Your organization's activation is currently in progress and should be completed within 2-3 business days. You'll receive an email notification as soon
        as the activation is complete.
    </p>
    <p>If you have any questions in the meantime, please don't hesitate to reach out.</p>
    <p>We're excited to have you join our network!</p>
    <div class="form-check">
        <input
            class="form-check-input me-2"
            type="checkbox"
            [(ngModel)]="hidePrompt"
            style="position: absolute !important; top: -1px" />
        <label class="form-check-label">Don't show this message again</label>
    </div>
</kno2-dialog-body>

<kno2-dialog-footer>
    <button
        class="btn btn-primary"
        (click)="ok()">
        Ok
    </button>
</kno2-dialog-footer>
